import React from 'react';
import Header from "./components/Header/Header"
import Editor from "./components/Editor/Editor"
import Config from "./components/Config/Config"
import Canvas from './components/Canvas/Canvas';
import Controls from './components/Controls/Controls';

import './ProductSheet.css';
import { TKModelProvider } from './context/TKModelContext';

const ProductSheet = ({enterpriseId,divisionId}) => {
    console.log(divisionId)
    return <TKModelProvider>
        <div className="product-sheet">
            <Header enterpriseId={enterpriseId}/>
            <div className='work-area'>
                <Editor>
                    <Canvas />
                    <Controls />
                </Editor>
                <Config divisionId={divisionId} enterpriseId={enterpriseId}/>
            </div>
        </div>
    </TKModelProvider>

}

export default ProductSheet;


